import * as React from "react";
import { SVGProps } from "react";
const SvgAllInOne = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 15h-9V6h3a6 6 0 0 0 6 6v3Zm-9 11h9v-9h-9v9ZM6 26h9v-9H6v9Zm0-11h9V6H6v9Zm16.791-8.758a.998.998 0 0 1 1.397-.221l.939.683 2.465-3.392a1 1 0 1 1 1.617 1.176l-3.052 4.2a.997.997 0 0 1-1.396.221l-1.749-1.27a1 1 0 0 1-.221-1.397ZM32 6a5.996 5.996 0 0 0-11.651-2H17a1 1 0 1 0-2 0H5a1 1 0 0 0-1 1v10a1 1 0 1 0 0 2v10a1 1 0 0 0 1 1h10a1 1 0 1 0 2 0h10a1 1 0 0 0 1-1V17a1 1 0 1 0 0-2v-3.349c2.329-.824 4-3.04 4-5.651Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAllInOne;
